import { useId } from 'react';
import { createPortal } from 'react-dom';
import { X } from 'lucide-react';
import { useDialog } from './useDialog';

const SlideOver = ({ isOpen, onClose, title, children, width = 'max-w-xl' }) => {
  const panelRef = useDialog(isOpen, onClose);
  const titleId = useId();

  if (!isOpen) return null;

  return createPortal(
    <div className="fixed inset-0 z-[1050]">
      <button
        type="button"
        tabIndex={-1}
        aria-label="Close panel"
        onClick={onClose}
        className="absolute inset-0 cursor-default bg-black/50 backdrop-blur-[2px]"
      />
      <div
        ref={panelRef}
        role="dialog"
        aria-modal="true"
        aria-labelledby={title ? titleId : undefined}
        tabIndex={-1}
        className={`absolute inset-y-0 right-0 flex w-full flex-col bg-theme-cardbg shadow-xl outline-none dark:bg-themedark-cardbg ${width}`}
      >
        <div className="flex items-center justify-between gap-3 border-b border-theme-border p-6 dark:border-themedark-border">
          <h5 id={titleId} className="text-f-h6 font-semibold text-theme-headings dark:text-themedark-headings">
            {title}
          </h5>
          <button type="button" onClick={onClose} aria-label="Close" className="btn btn-icon btn-link-secondary">
            <X className="w-5 h-5" />
          </button>
        </div>
        <div className="scrollbar flex-1 overflow-y-auto p-6">{children}</div>
      </div>
    </div>,
    document.body
  );
};

export default SlideOver;
